export default function csvToArr(csv, options = {}) {
  const delimiter = options.delimiter || ','
  return csv.split(/\n/)
    .map(line => line.split(delimiter))
}
